import { useState } from "react";
import {
  ExternalContainer,
  InternalContainer,
} from "../../../../components/Reusable/Layout";
import { DataPlansTable, DataPlanSearchFilter } from "./component";
import { CreateDataModal } from "../../Modal/Data/CreateDataModal";
import { Product } from "../../../../components/Reusable/type";
import { DataPlan } from "./types";
import { EditDataModal } from "../../Modal/Data/EditDataModal";
import { DeleteDataModal } from "../../Modal/Data/DeleteDataModal";
import { SortBy, SortOrder } from "../../../../features/auth/store/types/types";

interface DataPlansProps {
  dataPlans: Product[];
  loading?: boolean;
  error?: string | null;
  statusFilter: string;
  seerchTerm: string;
  setStatusFilter: (status: string) => void;
  onDataPlanClick: (dataPlan: Product) => void;
  searchTerm: string;
  setSearchTerm: (val: string) => void;
  categoryFilter: string;
  setCategoryFilter: (category: string) => void;
  countryFilter: string;
  setCountryFilter: (country: string) => void;
  sortBy: SortBy | "";
  setSortBy: (sortBy: SortBy | "") => void;
  sortOrder: SortOrder | "";
  setSortOrder: (sortOrder: SortOrder) => void;
}

const DataPlans: React.FC<DataPlansProps> = ({
  dataPlans,
  loading,
  error,
  statusFilter,
  seerchTerm,
  setStatusFilter,
  onDataPlanClick,
  searchTerm,
  setSearchTerm,
  categoryFilter,
  setCategoryFilter,
  countryFilter,
  setCountryFilter,
  sortBy,
  setSortBy,
  sortOrder,
  setSortOrder,
}) => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedDataPlan, setSelectedDataPlan] = useState<
    undefined | DataPlan
  >(undefined);
  const [dataPlanId, setDataPlanId] = useState<number | null>(null);

  const onEditClick = (data: DataPlan) => {
    setSelectedDataPlan(data);
    setIsEditModalOpen(true);
  };

  const onDeleteClick = (id: number) => {
    setDataPlanId(id);
    setIsDeleteModalOpen(true);
  };

  return (
    <ExternalContainer>
      <div className="min-h-screen dark:bg-[#FFFFFF1A] w-full max-w-7xl mx-auto px-4 py-6">
        <InternalContainer headerText="Data Plans">
          <div className="flex flex-col">
            <DataPlanSearchFilter
              onStatusFilter={setStatusFilter}
              searchTerm={searchTerm}
              onSearchChange={setSearchTerm}
              onCreateNewProduct={(type) => {
                setIsCreateModalOpen(true);
              }}
              categoryFilter={categoryFilter}
              onCategoryFilter={setCategoryFilter}
              countryFilter={countryFilter}
              onCountryFilter={setCountryFilter}
              sortBy={sortBy}
              onSortByChange={setSortBy}
              sortOrder={sortOrder}
              onSortOrderChange={setSortOrder}
            />
            <div className="border border-[#FFFFFF1A] overflow-x-auto">
              <DataPlansTable
                dataPlans={dataPlans as DataPlan[]}
                statusFilter={statusFilter}
                searchTerm={searchTerm}
                onDataPlanClick={onDataPlanClick}
                onEditClick={onEditClick}
                onDeleteClick={onDeleteClick}
                loading={loading}
              />
            </div>
          </div>
        </InternalContainer>
        <CreateDataModal
          isOpen={isCreateModalOpen}
          onClose={() => setIsCreateModalOpen(false)}
        />
        <EditDataModal
          dataPlan={selectedDataPlan}
          isOpen={isEditModalOpen && selectedDataPlan !== undefined}
          onClose={() => {
            setIsEditModalOpen(false);
            setSelectedDataPlan(undefined);
          }}
        />
        <DeleteDataModal
          id={dataPlanId}
          isOpen={isDeleteModalOpen && dataPlanId !== null}
          onClose={() => {
            setIsDeleteModalOpen(false);
            setDataPlanId(null);
          }}
        />
      </div>
    </ExternalContainer>
  );
};

export default DataPlans;
